import React from 'react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Textarea } from '../ui/textarea';

const RejectModal = ({ rejectModal, setRejectModal, rejectReason, setRejectReason, handleReject, processing }) => (
  <Dialog open={!!rejectModal} onOpenChange={() => setRejectModal(null)}>
    <DialogContent className="max-w-md z-50" data-testid="reject-modal">
      <DialogHeader>
        <DialogTitle>Reject {rejectModal?.number}</DialogTitle>
      </DialogHeader>
      <div className="space-y-4 mt-2">
        <div>
          <label className="text-sm font-medium text-gray-700 mb-1 block">Reason for rejection (optional)</label>
          <Textarea
            placeholder="Enter reason for rejection..."
            value={rejectReason}
            onChange={(e) => setRejectReason(e.target.value)}
            rows={3}
            data-testid="reject-reason-input"
          />
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={() => setRejectModal(null)} data-testid="reject-cancel-btn">Cancel</Button>
          <Button
            className="bg-red-600 hover:bg-red-700 text-white"
            onClick={handleReject}
            disabled={processing === rejectModal?.id}
            data-testid="reject-confirm-btn"
          >
            Reject Order
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);

export default RejectModal;
